import React from "react"

import { Container, Text, Div, Row, Col, Tag, Image } from "atomize"

import info from "../../images/info2.svg"
import person from "../../images/person.svg"
import position from "../../images/position.svg"

const list = [
  {
    icon: info,
    heading: "Informationen",
    subheading:
      "BürgerInnen jederzeit über aktuelle Maßnahmen und Empfehlungen informieren und sensibilisieren.",
    // link: "/docs/react/theme#columnCount",
  },
  {
    icon: position,
    heading: "Testen",
    subheading:
      "Für eine Eindämmung der Corona-Pandemie ist es essentiell, begründete Verdachtsfälle möglichst schnell zu identifizieren und zu kontaktieren.",
    // link: "/docs/react/theme#availableColors",
  },

  {
    icon: person,
    heading: "Auskunft",
    subheading: "Die erhöhte Anzahl an Anfragen von BürgerInnen verarbeiten.",
    // link: "/docs/react/spacing",
  },
]

const Herausforderung = () => (
  <Div tag="section" id="features" p={{ t: "8rem" }}>
    <Container>
      <Tag
        bg="success800"
        textColor="white"
        h="2rem"
        p={{ x: "1rem" }}
        rounded="circle"
        m={{ b: "2rem" }}
      >
        #GemeinsamGegenCorona
      </Tag>
      <Text
        textSize={{ xs: "title", sm: "heading", md: "display1" }}
        textWeight="500"
        fontFamily="secondary"
        m={{ b: "1rem" }}
      >
        Die Herausforderung
      </Text>
      <Text
        textSize="subheader"
        textColor="medium"
        maxW="35rem"
        m={{ b: "3rem" }}
      >
        Die Corona Pandemie führt zu einem extrem erhöhten Bedarf der
        BürgerInnen an Informationen und Beratung und stellt Behörden so vor
        drei grundlegende <strong>Kommunikationsherausforderungen</strong>:
      </Text>
      <Div p={{ b: "6rem" }} border={{ b: "1px solid" }} borderColor="gray300">
        <Row>
          {list.map(item => (
            <Col size={{ xs: 12, sm: 6, lg: 4 }} key={item.heading}>
              <Div m={{ b: { xs: "1rem", lg: "0" } }}>
                <Div
                  border="1px solid"
                  borderColor="gray300"
                  h={{ xs: "100%", sm: "22rem", md: "20rem" }}
                  maxH="22rem"
                  d="flex"
                  flexDir="column"
                  p="2rem"
                  shadow="4"
                  rounded="xl"
                >
                  <Div flexGrow="1">
                    <Image
                      src={item.icon}
                      m={{ t: "0.5rem", b: "1rem" }}
                      w="auto"
                      h="3rem"
                    />
                    <Text textSize="title" textWeight="500" m={{ b: "1rem" }}>
                      {item.heading}
                    </Text>
                    <Text
                      textSize="subheader"
                      textColor="medium"
                      m={{ b: "2rem" }}
                    >
                      {item.subheading}
                    </Text>
                  </Div>
                  {/* <Link to={item.link}>
                        <Text
                          textColor="info700"
                          hoverTextColor="info800"
                          textWeight="500"
                        >
                          See How
                        </Text>
                      </Link> */}
                </Div>
              </Div>
            </Col>
          ))}
        </Row>
      </Div>
    </Container>
  </Div>
)

export default Herausforderung
